import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  ListCellDefDirective,
  ListModuleColumnDef,
  ListModuleTableComponent,
} from 'src/app/shared/components/list-module';
import { IconModule } from 'src/app/shared/icon/icon.module';
import { HasPermissionPipe } from 'src/app/core/pipes/has-permission.pipe';
import { SUPER_ADMIN_PERMISSION_SLUGS } from 'src/app/core/constants/super-admin-permission-slugs';
import type { EmailTemplateRow } from 'src/app/core/services/email-template-api.service';

@Component({
  selector: 'app-email-configuration-table',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    IconModule,
    HasPermissionPipe,
    ListModuleTableComponent,
    ListCellDefDirective,
  ],
  templateUrl: './email-configuration-table.component.html',
  styleUrl: './email-configuration-table.component.css',
})
export class EmailConfigurationTableComponent {
  readonly P = SUPER_ADMIN_PERMISSION_SLUGS;

  @Input() rows: EmailTemplateRow[] = [];
  @Input() loading = false;
  @Input() emptyMessage = 'No email templates found.';

  @Output() toggleStatus = new EventEmitter<EmailTemplateRow>();
  @Output() preview = new EventEmitter<EmailTemplateRow>();

  readonly columns: ListModuleColumnDef[] = [
    { id: 'template_name', header: 'Template name', cellClass: 'font-semibold' },
    { id: 'subject', header: 'Subject', cellClass: 'max-w-[280px] truncate text-sm' },
    { id: 'status', header: 'Status', align: 'center', cellClass: 'whitespace-nowrap' },
    { id: 'actions', header: 'Action', align: 'right', cellClass: 'text-end whitespace-nowrap' },
  ];

  editLink(id: number): string[] {
    return ['/system-preferences/email-template', String(id)];
  }

  statusLabel(active: boolean | null | undefined): string {
    return active ? 'Active' : 'Inactive';
  }

  statusClass(active: boolean | null | undefined): string {
    return active
      ? 'text-success font-semibold'
      : 'text-gray-500 dark:text-gray-400 font-semibold';
  }
}
